<template>
  <div class="hello" v-if="currentQcount < questionSet.length" :class="currentQ.type">
    <header class="wrap">
      <h1>States of Matter and Phase Changes</h1>
      <h2>Score: {{currentScore}}</h2>
      <span>Question {{currentQcount+1}} / {{questionSet.length}}</span>
    </header>
    <div class="debug" style="width:200px;" v-if="false">
      Debugging<br>
      The answer is {{this.currentQ.answer}}<br>
      {{this.currentQ}}<br>
      <button v-on:click="resetEverything">Restart</button><br>
    </div>

    <div class="questionAset wrap" v-if="currentQ.type == 'A'">
      <div class="question">
        <div class="info">
          <div class="sample">{{this.currentQ.sample}} (<span v-html="currentQ.symbol"></span>)</div>
          <div class="freezmelt">Freezing/Melting Point <span>{{this.currentQ.freezmelt}}⁰C</span></div>
          <div class="boilpoint">Boiling Point <span>{{this.currentQ.boil}}⁰C</span></div>
        </div>
        <div class="temp">
          <span>Temperature</span>
          <strong>{{this.currentQ.current}}⁰C</strong>
        </div>
      </div>

      <p>What state of matter is this sample of {{this.currentQ.sample}} (<span v-html="currentQ.symbol"></span>)?</p>

      <div class="choices">
        <div class="c">
            <div>
              <input name="answerTypeA" type="radio" v-model="answerTypeA" value="C" id="answerC">
              <label for="answerC" :class="classAnswerC">
                <div class="solid sphere">
                  <img src="../assets/01_SPHERES-SOLID.gif" alt="">
                  <!--template v-for="x in 14">
                    <template v-for="y in 14">
                      <img :key="'solid'+x+'_'+y" src="../assets/sphere.png" alt="" :style="'top:'+((x*16)-17)+'px;left:'+((y*16)-17)+'px;'">
                    </template>
                  </template-->
                </div>
                <span>Solid</span>
              </label>
            </div>
        </div>
        <div class="b">
            <div>
              <input name="answerTypeA" type="radio" v-model="answerTypeA" value="B" id="answerB">
              <label for="answerB" :class="classAnswerB">
                <div class="liquid sphere">
                  <img src="../assets/02_SPHERES-LIQUID.gif" alt="">
                  <!--template v-for="x in 9">
                    <template v-for="y in 9">
                      <img :key="'liquidback'+x+'_'+y" src="../assets/sphere.png" alt="" :style="'top:'+((y*17)-7)+'px;left:'+((x*17)-7)+'px;'" class="back">
                    </template>
                  </template>

                  <template v-for="x in 8">
                    <template v-for="y in 8">
                      <img :key="'liquid'+x+'_'+y" src="../assets/sphere.png" alt="" :style="'top:'+((x*17)-15)+'px;left:'+((y*17)-15)+'px;'">
                    </template>
                  </template-->
                </div>
                <span>Liquid</span>
              </label>
            </div>
        </div>
        <div class="a">
            <div>
              <input name="answerTypeA" type="radio" v-model="answerTypeA" value="A" id="answerA">
              <label for="answerA" :class="classAnswerA">
                <div class="gas sphere">
                  <img src="../assets/03_SPHERE-GAS.gif" alt="">
                  <!--template v-for="n in 10">
                    <img :key="'gas'+n" src="../assets/sphere.png" alt="Gas" :style="randomPos[n]">
                  </template-->
                </div>
                <span>Gas</span>
              </label>
            </div>
        </div>
      </div>
      <div class="error"
        v-show="classAnswerA==='wrong'||classAnswerB==='wrong'||classAnswerC==='wrong'">
        Sorry, this incorrect, try again.
      </div>
      <div class="error" v-show="doubleWrong===true">
        The correct answer is selected.
      </div>
      <div class="success" v-show="rightRight===true">
        Correct!
      </div>
      <div class="submit btn" v-on:click="checkAnswer" v-show="doubleWrong===false&&rightRight===false">Submit</div>
      <div class="submit btn" v-on:click="checkAnswer" v-show="doubleWrong===true||rightRight===true">Continue</div>
      <p class="small">Use the data provided to help answer the question</p>
    </div>

    <div class="questionBset" v-if="currentQ.type == 'B'">
      <div class="wrap">

        <p>Identify the phase change that is occuring based on the change in the behavior of particles shown</p>

        <div class="questionB-answer-wrapper" :class="currentQ.answer != answerTypeB ? 'wrong' : ''">
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Melting" id="Melting">
            <label for="Melting" :class="answerMelting">Melting</label>
          </div>
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Freezing" id="Freezing">
            <label for="Freezing" :class="answerFreezing">Freezing</label>
          </div>
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Evaporation" id="Evaporation">
            <label for="Evaporation" :class="answerEvaporation">Evaporation</label>
          </div>
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Condensation" id="Condensation">
            <label for="Condensation" :class="answerCondensation">Condensation</label>
          </div>
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Sublimation" id="Sublimation">
            <label for="Sublimation" :class="answerSublimation">Sublimation</label>
          </div>
          <div>
            <input name="answerTypeB" type="radio" v-model="answerTypeB" value="Deposition" id="Deposition">
            <label for="Deposition" :class="answerDeposition">Deposition</label>
          </div>
        </div>

        <div class="animation">
          <div class="video-wrap">
            <video id="video" autoplay muted :src="baseUrl+'videos/'+this.currentQ.video" width="712" height="400"></video>
          </div>
        </div>

        <button class="replay" v-on:click="replay">&#8634;</button>

        <div class="error"
          v-show="answerMelting==='wrong'||answerFreezing==='wrong'||answerEvaporation==='wrong'||answerCondensation==='wrong'||answerDeposition==='wrong'||answerSublimation==='wrong'">
          Sorry, this incorrect, try again.
        </div>
        <div class="error" v-show="doubleWrong===true">
          The correct answer is selected.
        </div>
        <div class="success" v-show="rightRight===true">
          Correct!
        </div>
        <div class="submit btn" v-on:click="checkAnswer" v-show="doubleWrong===false&&rightRight===false">Submit</div>
        <div class="submit btn" v-on:click="checkAnswer" v-show="doubleWrong===true||rightRight===true">Continue</div>
      </div>
    </div>

  </div>
  <div class="outro" v-else-if="currentQcount == questionSet.length">

    <h1>The end!</h1>
    <p>You scored {{currentScore}} out of a possible {{questionSet.length}}.</p>

    <button class="btn" v-on:click="resetEverything">Start Over</button>

  </div>
</template>

<script>
export default {
  name: 'Quiz',
  props: [
    'questionAs',
    'questionBs'
  ],
  data: function() {
    return {
      baseUrl: process.env.BASE_URL,
      randomNs: [],
      randomPos: [],
      interval: false,
      flipflops: [],
      currentQ: {},
      currentQCount: 0,
      questionSet: [],
      answerTypeA: '',
      answerTypeB: '',
      classAnswerA: '',
      classAnswerB: '',
      classAnswerC: '',
      answerMelting: '',
      answerFreezing: '',
      answerEvaporation: '',
      answerCondensation: '',
      answerDeposition: '',
      answerSublimation: '',
      wasWrong: false,
      doubleWrong: false,
      rightRight: false
    }
  },
  methods: {
    resetEverything: function() {
      this.setQuestions();
      this.$emit('restartQuiz');
    },
    dotUp: function() {
      this.randomNs = [];
      for(var i=0;i<=10;i++) {
        var r = Math.floor(Math.random() * 180);
        if(Math.random() > 0.5) {
          this.randomNs.push({x:r,y:0});
        } else {
          this.randomNs.push({x:0,y:r});
        }
        this.randomPos[i] = 'transform:translate('+this.randomNs[i].x+'px,'+this.randomNs[i].y+'px)';
        this.flipflops[i] = 0;
      }

      //update the random x/y coords every 5 seconds
      clearInterval(this.interval);
      this.interval = setInterval(() => {

          for(var i=0;i<10;i++) {
            if(Math.random() > 0.5 && this.flipflops[i] === 0) {
              this.flipflops[i]++;
              var flipfloppingSide = 0;
              if(Math.random() > 0.5) { flipfloppingSide = 180; }

              var randomPosition = Math.floor(Math.random() * 80) + 40;
              if(Math.random() > 0.5) {
                this.randomNs[i] = {x:randomPosition,y:flipfloppingSide};
              } else {
                this.randomNs[i] = {x:flipfloppingSide,y:r};
              }

              this.$set(this.randomPos, i, 'transform:translate('+this.randomNs[i].x+'px,'+this.randomNs[i].y+'px)');
            } else {
              if(this.flipflops[i] > 0) {
                this.flipflops[i]++;
                if(this.flipflops[i] >= 10) {
                  this.flipflops[i] = 0;
                }
              }
            }
          }

      }, 100);

    },
    setQuestions: function () {
      //7 random As
      var randomAs = this.questionAs.sort(() => .5 - Math.random()).slice(0,7);
      //3 random Bs
      var randomBs = this.questionBs.sort(() => .5 - Math.random()).slice(0,3);
      var allRandoms = randomAs.concat(randomBs);
      //one liner array shuffle
      var newSet = allRandoms.reduce((a,v)=>a.splice(Math.floor(Math.random() * a.length), 0, v) && a, []);
      this.questionSet = newSet;
      this.currentQ = this.questionSet[0];
      this.currentQcount = 0;
      this.currentScore = 0;
      this.wasWrong = false;
      this.resetClasses();
    },
    checkAnswer: function() {
      if(this.currentQ.type === 'A') {
        var a = this.currentQ.answer;
        if(this.answerTypeA === '') { return; }
        if(this.rightRight === true || this.doubleWrong === true) {
          this.nextQuestion();
        } else if(a === this.answerTypeA) {
          if(this.wasWrong===false) {
            this.currentScore++;
          }
          this.rightRight = true;
        } else {
          if(this.wasWrong === true) {
            this.doubleWrong = true;
            this.answerTypeA = this.currentQ.answer;
          } else {
            this.wasWrong = true;
            this['classAnswer' + this.answerTypeA] = 'wrong'
          }
        }
      } else if(this.currentQ.type === 'B') {
        var b = this.currentQ.answer;
        if(this.answerTypeB === '') { return; }
        if(this.rightRight === true || this.doubleWrong === true) {
          this.nextQuestion();
        } else if(b === this.answerTypeB) {
          if(this.wasWrong===false) {
            this.currentScore++;
          }
          this.rightRight = true;
        } else {
          if(this.wasWrong === true) {
            this.doubleWrong = true;
            this.answerTypeB = this.currentQ.answer;
          } else {
            this.wasWrong = true;
            this['answer' + this.answerTypeB] = 'wrong'
          }
        }
      }
    },
    nextQuestion: function() {
      this.currentQcount++;
      this.answerTypeA = '';
      this.answerTypeB = '';
      this.currentQ = this.questionSet[this.currentQcount];
      this.wasWrong = false;
      this.doubleWrong = false;
      this.rightRight = false;
      this.resetClasses();
    },
    resetClasses: function() {
      this.classAnswerA = '';
      this.classAnswerB = '';
      this.classAnswerC = '';
      this.answerMelting = '';
      this.answerFreezing = '';
      this.answerEvaporation = '';
      this.answerCondensation = '';
      this.answerDeposition = '';
      this.answerSublimation = '';
    },
    replay: function() {
      var vid = document.getElementById('video');
      vid.pause();
      vid.currentTime = '0';
      vid.play();
    }
  },
  watch: {
    answerTypeA: function (newV, oldV) {
      if (newV !== oldV) {
        this.resetClasses();
      }
    },
    answerTypeB: function (newV, oldV) {
      if (newV !== oldV) {
        this.resetClasses();
      }
    }
  },
  created: function () {
    this.dotUp();
    this.setQuestions();
  },
  beforeDestroy: function () {
    clearInterval(this.interval);
  }
}
</script>

<style lang="scss">
@import "../assets/styles.scss";
header {
  display: flex;
  justify-content: space-between;
  h1, h2, span { 
    display: inline-block; 
    margin: 1em 0;
    font-size: 1rem;
    text-transform: uppercase;
  }
}
.B {
  background: #1c1c1c;
  header {
    color: $lt_grey;
  }
}
.debug {
  position: fixed;
  top: 0;
  right: 0;
  padding: 10px;
  border: solid 1px #000;
  background: #888;
  color: #fff;
  font-size: 14px;
}
.question {
  margin: auto;
  .info {
    display: flex;
    margin: 10px auto;
    justify-content: space-between;
  }
  .sample { 
    color: #4872bc; 
    white-space: nowrap;
    padding: 1rem 0 0;
  }
  .freezmelt, .boilpoint {
    width: 38%;
    color: #fff;
    padding: 1rem;
    font-size: 1rem;
    height: 3rem;
    white-space: nowrap;
    text-align: left;
    position: relative;
    span { 
      position: absolute; 
      top: 0; 
      right: 0; 
      background: #fff; 
      padding: 1rem 1.5rem; 
      color: $dk_grey; 
      font-weight: bold; 
      font-size: 1.25rem; 
      line-height: 1rem; 
      height: 3rem;
    }
  }
  .freezmelt { 
    background: #4872bc; 
    span { border: solid 1px #4872bc; }
  }
  .boilpoint {
    background: #ba495f;
    span { border: solid 1px #ba495f; }
  }
  .temp {
    text-align: center;
    span {
      display: block;
      text-transform: uppercase;
      letter-spacing: 12px;
      margin: 2rem auto 0;
    }
    strong {
      font-size: 7rem;
      line-height: 10rem;
      font-weight: normal;
    }
  }

}
.choices { 
  display: flex;
  margin: 1rem auto 0;
  justify-content: space-around;

  input { display: none; }
  input + label {
    display: inline-block;
    cursor: pointer;
    span {
      margin: 1rem auto 0;
      border: solid 1px #000;
      color: $dk_grey;
      padding: 0.5rem 2rem;
      display: block;
    }
  }
  input:checked + label {
    span { 
      background: #ccc;
      color: #1b1b1b;
      border-color: $blue;
      box-shadow: 0 0 0 2px $blue;
    }
    .sphere { border-color: $blue; box-shadow: 0 0 0 2px $blue; }
    &.wrong { span, img { border-color: red; } }
    &:hover { cursor: default; }
  }
  .sphere {
    display: block;
    width: 10rem;
    height: 10rem;
    max-width: 100%;
    border-radius: 50%;
    border: solid 2px #ccc;
    background: #fff;
    overflow: hidden;
    position: relative;
    z-index: 3;
  }
  img { width: 100%; height: auto; }
  /*
  img {
    width: 1.1rem;
    height: auto;
    position: absolute;
  }
  */
}
/*
.gas {
  img { 
    top: -20px;
    left: -20px;
    transition: all 0.8s linear;
  }
}
.liquid {
  img {
    z-index: 2;
    &.back { 
      filter: brightness(80%);
      border-radius: 1rem;
      z-index: 1;
    }
    &.back { 
      filter: brightness(60%);
      border-radius: 1rem;
      z-index: 1;
    }
    animation: wig 5s infinite linear;
    &:nth-of-type(even) {
      animation: wib 5s infinite linear;
      animation-delay: 0.5s;
    }
    &:nth-of-type(3n+0) {
      animation: wiggle 6s infinite linear;
    }
    &:nth-of-type(4n+0) {
      animation: waggle 5s infinite ease;
      animation-delay: 0.5s;
    }
    &:nth-of-type(5n+0) {
      transform-origin: 0 10px;
      animation: wob 8s infinite ease-in-out;
    }
    &:nth-of-type(6n+0) {
      transform-origin: 0 10px;
      animation: wob 7s infinite linear;
      animation-delay: 0.2s;
    }
    &:nth-of-type(7n+0) {
      transform-origin: 10px 0;
      animation: wag 6s infinite linear;
    }
    &:nth-of-type(8n+0) {
      animation-delay: 0.3s;
    }
    &:nth-of-type(10n+0) {
      animation: wob 7s infinite ease-in-out;
      animation-delay: 0.4s;
    }
    &:nth-of-type(15n+0) {
      animation-delay: 0.1s;
    }
    &:nth-of-type(3n+1) { animation-delay: 1s; }
    &:nth-of-type(3n+2) { animation-delay: 0.2s; }
    &:nth-of-type(3n+3) { animation-delay: 0.3s; }
  }
}
@keyframes wob {
  0% { transform: translate(0,0) rotate(0deg); transform-origin: 0 10px; }
  50% { transform: translate(20px,-20px) rotate(360deg); transform-origin: 10px 0; }  
  100% { transform: translate(0,0) rotate(720deg); transform-origin: 0 10px; }
}
@keyframes wib {
  0% { transform: translate(0,0) rotate(0deg); }
  50% { transform: translate(-20px,20px) rotate(360deg); }  
  100% { transform: translate(0,0) rotate(720deg); }
}
@keyframes wag {
  0% { transform: translate(0,0) rotate(0deg); transform-origin: 10px 0 }
  50% { transform: translate(30px,-10px) rotate(360deg); transform-origin: 20px 0 }
  0% { transform: translate(0,0) rotate(720deg); transform-origin: 10px 0 }
}
@keyframes wig {
  0% { transform: translate(0,0) rotate(360deg); }
  50% { transform: translate(0,30px) rotate(0deg); }
  100% { transform: translate(0,0) rotate(360deg); }
}
@keyframes wiggle {
  0% { transform: translate(0,0) rotate(360deg); }
  50% { transform: translate(20px,10px) rotate(0deg); }
  100% { transform: translate(0,0) rotate(360deg); }
}
@keyframes waggle {
  0% { transform: translate(0,0) rotate(360deg); }
  50% { transform: translate(0,50px) rotate(0deg); }
  100% { transform: translate(0,0) rotate(360deg); }
}
.solid {
  img {
    animation: vibrate 1s infinite linear both;
    &:nth-of-type(even) {
      animation-delay: 0.5s;
    }
  }
}
@keyframes vibrate {
  0% { transform: translate(0,0); }
  50% { transform: translate(4%,0) rotate(5deg); }
  100% { transform: translate(0,0); }
}
*/
.small { font-size: 1rem; margin: 2rem auto; }
.submit { margin: 3rem auto 0; max-width: 24em; }
.questionAset { position: relative; }
.error { position: absolute; width:100%; text-align: center; color: red; font-weight: bold; margin: 1rem 0; }
.success { position: absolute; width:100%; text-align: center; color: green; font-weight: bold; margin: 1rem 0; }
.questionBset {

  min-height: 100vh;

  input { display: none; }
  input + label {
    display: inline-block;
    cursor: pointer;
    margin: 1rem auto 0;
    border: solid 1px #000;
    border-radius: 2rem;
    color: $dk_grey;
    background: #fff;
    padding: 0.5rem 1rem;
    font-size: 1.15rem;
    min-width: 7.5rem;
  }
  input:checked + label {
    background: #ccc;
    color: #1b1b1b;
    border-color: $blue;
    box-shadow: 0 0 0 2px $blue;
    &.wrong { color: #fff; background: red; box-shadow: none; border-color: red; }
    &:hover { cursor: default; }
  }

  p { 
    color: #fff; 
    margin: 1em 0;
    font-size: 1rem;
  }

  .wrap { position: relative; }

}
.questionB-answer-wrapper { 
  display: flex; 
  align-items: center;
  justify-content: space-between;
}
.animation {
  position: relative;
  background: #333;
  min-height: 360px;
  margin: 2rem auto;
}

.video-wrap,
.video-wrap video {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height:  100%;
}

.replay {
  background: #000 url(../assets/replay.png) no-repeat center center;
  width: 60px;
  height: 60px;
  margin: 0 auto;
  font-size: 0;
  border: 0;
  position: relative;
  top: -10px;
}
.questionBset {
  .submit { margin-top: 20px; }
  .error, .success { margin: -0.45rem 0 1rem;  }
}
.outro {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  flex-direction: column;
  h1, p { 
    margin: 0 auto 2.5rem;
    line-height: 1.5;
  }
  h1 { letter-spacing: 1.5px; }
}
</style>
